import { h, Host, writeTask } from "@stencil/core";
export class Zoom {
    constructor() {
        this.zoomLevel = 4;
        this.useSquareImages = true;
        this.onScroll = () => {
            this.getRect();
        };
        this.onResize = () => {
            this.getRect();
        };
        this.onMouseEnter = (event) => {
            this.body.classList.add('product-zoom-active');
            this.getRect();
            const offset = this.calculateOffset(event);
            this.moveMark(offset.x, offset.y);
        };
        this.onMouseLeave = () => {
            this.body.classList.remove('product-zoom-active');
        };
        this.onMouseMove = (event) => {
            const offset = this.calculateOffset(event);
            this.moveMark(offset.x, offset.y);
        };
    }
    componentDidLoad() {
        this.body = document.querySelector('body');
        const magnifierContainer = this.el.querySelector('magnifier-container');
        magnifierContainer.addEventListener('mouseenter', this.onMouseEnter);
        magnifierContainer.addEventListener('mouseleave', this.onMouseLeave);
        magnifierContainer.addEventListener('mousemove', this.onMouseMove);
        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onResize);
        writeTask(() => {
            this.imageElement = magnifierContainer.querySelector('img');
            this.getRect();
        });
        this.elementObserver = new IntersectionObserver(_ => {
            setTimeout(() => {
                this.getRect();
            }, 600); // slider speed for animation
        }, {});
        this.elementObserver.observe(this.el);
    }
    disconnectedCallback() {
        const magnifierContainer = this.el.querySelector('magnifier-container');
        magnifierContainer.removeEventListener('mouseenter', this.onMouseEnter);
        magnifierContainer.removeEventListener('mouseleave', this.onMouseLeave);
        magnifierContainer.removeEventListener('mousemove', this.onMouseMove);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
    }
    getRect() {
        if (this.useSquareImages) {
            this.rect = this.el.getBoundingClientRect();
        }
        else {
            this.rect = this.el.querySelector('picture').getBoundingClientRect();
        }
    }
    calculateOffset(mouseEvent) {
        if (this.useSquareImages) {
            this.rect = this.rect || mouseEvent.target.getBoundingClientRect();
        }
        else {
            this.rect = this.rect || mouseEvent.target.querySelector('picture').getBoundingClientRect();
        }
        const offsetX = mouseEvent.clientX - this.rect.left;
        const offsetY = mouseEvent.clientY - this.rect.top;
        return { x: offsetX, y: offsetY };
    }
    moveMark(offsetX, offsetY) {
        let x = offsetX - 100 / 2, y = offsetY - 100 / 2;
        // Don't use negative offset
        x = x < 0 ? 0 : x;
        y = y < 0 ? 0 : y;
        x = x > (this.rect.width - 100) ? (this.rect.width - 100) : x;
        y = y > (this.rect.height - 100) ? (this.rect.height - 100) : y;
        this.setMagnifierProperties(x, y);
        this.updateZoomed(x, y, this.imageElement.width, this.imageElement.height);
    }
    updateZoomed(originalX, originalY, originalWidth, originalHeight) {
        let paddingWidth = this.zoomLevel * (Math.abs(originalHeight - originalWidth) / 2) + 'px', padding = (originalHeight > originalWidth) ? '0px ' + paddingWidth : paddingWidth + ' 0px', width = this.zoomLevel * ((originalHeight > originalWidth) ? originalHeight : originalWidth);
        if (this.useSquareImages) {
            this.setImageProperties(width, width, padding, -this.zoomLevel * originalY, -this.zoomLevel * originalX);
        }
        else {
            const width = this.zoomLevel * originalWidth, height = this.zoomLevel * originalHeight, padding = '0px';
            this.setImageProperties(width, height, padding, -this.zoomLevel * originalY, -this.zoomLevel * originalX);
        }
    }
    setMagnifierProperties(x, y) {
        this.magnifierProperties = {
            top: `${y}px`,
            left: `${x}px`,
        };
    }
    setImageProperties(width, height, padding, top, left) {
        this.imageProperties = {
            width: `${width}px`,
            height: `${height}px`,
            padding: padding,
            top: `${top}px`,
            left: `${left}px`,
        };
        this.productZoomChanged.emit({
            image: this.image,
            imageProperties: this.imageProperties,
        });
    }
    render() {
        let styles = {};
        if (this.rect && this.rect.width > 0) {
            if (this.useSquareImages) {
                styles['height'] = `${this.rect.width}px`;
            }
            else {
                styles['height'] = `${this.rect.height}px`;
            }
        }
        return h(Host, { key: '9c2c7d8104bbe81138af94be5f586cc1453ee576', style: styles }, h("magnifier-container", { key: 'c0df2ba5c7bdc5f26ac75ff35f9b149db176afe6' }, h("slot", { key: 'be00bcac2c97dfd23dcd726b5c5640530b39f25a' }), h("magnifier", { key: 'e289109ae047cb550993c6ada51c1b5ddfb47b5a', style: this.magnifierProperties })));
    }
    static get is() { return "uvex-zoom"; }
    static get properties() {
        return {
            "image": {
                "type": "string",
                "attribute": "image",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "zoomLevel": {
                "type": "number",
                "attribute": "zoom-level",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "4"
            },
            "useSquareImages": {
                "type": "boolean",
                "attribute": "use-square-images",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "true"
            }
        };
    }
    static get states() {
        return {
            "imageElement": {},
            "rect": {},
            "magnifierProperties": {},
            "imageProperties": {}
        };
    }
    static get events() {
        return [{
                "method": "productZoomChanged",
                "name": "productZoomChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "{\n    image: string,\n    imageProperties: ProductZoomImageInterface\n  }",
                    "resolved": "{ image: string; imageProperties: ProductZoomImageInterface; }",
                    "references": {
                        "ProductZoomImageInterface": {
                            "location": "import",
                            "path": "../product-images/product-image-interfaces",
                            "id": "source/js/components/product-images/product-image-interfaces.ts::ProductZoomImageInterface"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=zoom.js.map
